export default "__VITE_ASSET__C3x_Zge$__"